import React, { useEffect, useState } from "react";

const NotFound = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      {/* <h1 style={{ fontSize: "4rem", marginBottom: "1rem" }}>404</h1> */}
      <p style={{ fontSize: "1.5rem" }}>Page In Progress</p>
    </div>
  );
};

export default NotFound;
